import React from 'react';
import { useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';
import { searchRoutes } from '../../../../constants';
import { useSearchStore } from '../../../../store/store';
import { OFFICE_BRKDWN_GROWTH_TAB_INDEX } from '../../../constants/breakdowns';

const OfficeNameLink = ({ data }) => {
    const history = useHistory();
    const {
        selectedBreakdownTab,
        setSelectedBreakdownTab,
        setSelectedBreakdownOffice,
    } = useSearchStore((state) => ({
        selectedBreakdownTab: state[state.selectedModule]?.breakdowns?.selectedBreakdownTab,
        setSelectedBreakdownTab: state.setSelectedBreakdownTab,
        setSelectedBreakdownOffice: state.setSelectedBreakdownOffice
    }));
    const handleClick = () => {
        setSelectedBreakdownOffice({ officeId: data.officeId, name: data.officeName });
        if (selectedBreakdownTab === OFFICE_BRKDWN_GROWTH_TAB_INDEX) setSelectedBreakdownTab(0);
        history.push(
            searchRoutes.agentsGainedBreakdown,
            { fromOfficeBreakdownAndGrowthTab: selectedBreakdownTab === OFFICE_BRKDWN_GROWTH_TAB_INDEX },
        );
    };
    return (
        <span className='table-row-link clickable' onClick={handleClick} >
            {data.officeName}
        </span>
    );
};

OfficeNameLink.propTypes = {
    data: PropTypes.objectOf({
        officeId: PropTypes.number.isRequired,
        officeName: PropTypes.string.isRequired
    })
};

export default OfficeNameLink;
